import * as React from 'react';
import {connect} from 'react-redux';

import type {NutshellState} from '../../../../../../store';

import {PAST, TODAY, TOMORROW, FUTURE} from '../../todos-constants';
// @ts-expect-error
import * as selectors from '../../todos-selectors';

import {ControlButton} from './control-button';

import styles from './todo-list-controls.module.css';

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        todayHasOverdue: selectors.getTodoTodayHasOverdue(state),
    };
};

export type TodoPeriodSegment = 'TODAY' | 'PAST' | 'TOMORROW' | 'FUTURE';

type OwnProps = {
    activePeriodSegment: TodoPeriodSegment;
    onSelect: (newPeriod: TodoPeriodSegment) => void;
    counts: {
        past: number;
        today: number;
        tomorrow: number;
        future: number;
    };
};

type StateProps = {
    todayHasOverdue: boolean;
};

type Props = OwnProps & StateProps;

export class TodoListControlsComponent extends React.Component<Props> {
    render() {
        return (
            <div>
                <div className={styles.container}>
                    <ControlButton
                        name={PAST}
                        label='Past'
                        count={this.props.counts.past}
                        isSelected={this.props.activePeriodSegment === PAST}
                        hasOverdue={this.props.counts.past > 0}
                        onSelect={this.props.onSelect}
                    />
                    <ControlButton
                        name={TODAY}
                        label='Today'
                        count={this.props.counts.today}
                        isSelected={this.props.activePeriodSegment === TODAY}
                        hasOverdue={this.props.todayHasOverdue}
                        onSelect={this.props.onSelect}
                    />
                    <ControlButton
                        name={TOMORROW}
                        label='Tomorrow'
                        count={this.props.counts.tomorrow}
                        isSelected={this.props.activePeriodSegment === TOMORROW}
                        onSelect={this.props.onSelect}
                    />
                    <ControlButton
                        name={FUTURE}
                        label='Future'
                        count={this.props.counts.future}
                        isSelected={this.props.activePeriodSegment === FUTURE}
                        onSelect={this.props.onSelect}
                    />
                </div>
            </div>
        );
    }
}

// @ts-expect-error
export const TodoListControls = connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(
    TodoListControlsComponent
);
